import { EventsName } from '@space-events/constants'

const refreshThemeEventDispatch = (theme: string) => {
  window.dispatchEvent(new CustomEvent(EventsName.REFRESH_THEME, { detail: { theme } }))
}
const refreshThemeEventListener = (listener: (themeRefresh) => void) => {
  window.addEventListener(EventsName.REFRESH_THEME, listener)

  return () => {
    window.removeEventListener(EventsName.REFRESH_THEME, listener)
  }
}

export { refreshThemeEventDispatch, refreshThemeEventListener }
